import {DateTime} from "luxon";
import {Entity} from "./entity";

export class Keyword extends Entity<Keyword> {

    private _deletedAt: DateTime | null = null;

    public get deletedAt(): DateTime | null {
        return this._deletedAt;
    }

    public set deletedAt(value: DateTime | null) {
        this._deletedAt = value;
    }

    public get isDeleted(): boolean {
        return this._deletedAt instanceof DateTime;
    }

    private _key: string = ``;

    get key(): string {
        return this._key;
    }

    set key(value: string) {
        this._key = value;
        this._setOriginalValue(`key`, value);
    }

    private _shortcut: string = ``;

    public get shortcut(): string {
        return this._shortcut;
    }

    public set shortcut(value: string) {
        this._shortcut = value;
        this._setOriginalValue(`shortcut`, value);
    }

    public toString(): string {
        return this.key;
    }

}